/** @module Classes */ /** typedoc */
class ModelStateError {
    static fromMonolith(input = {}) {
        const newModelStateError = new ModelStateError();
        newModelStateError.code = input.errorCode;
        newModelStateError.message = input.errorMessage;
        newModelStateError.field = input.field;
        return newModelStateError;
    }
}

export { ModelStateError };
